import { render, staticRenderFns } from "./GeneratorWeeks.vue?vue&type=template&id=36a533fd&"
import script from "./GeneratorWeeks.vue?vue&type=script&lang=js&"
export * from "./GeneratorWeeks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports